<template>
  <v-dialog v-model="internalValue" max-width="800px" content-class="rounded-xl">
    <v-card class="pa-6 rounded-xl">
      <!-- Title -->
      <v-card-title class="justify-center pb-6 pt-2">
        <h2 class="text-h5 font-weight-bold" style="color: #1c1f4c;">Bitácora</h2>
      </v-card-title>

      <!-- Content -->
      <v-card-text class="px-0 pb-0" style="max-height: 60vh; overflow-y: auto;">
        <v-expansion-panels v-model="panel" flat accordion>
          <v-expansion-panel v-for="(item, i) in items" :key="`panel-${item._uid}`" class="mb-4 rounded-lg"
            style="border: 1px solid #f0f0f0; box-shadow: 0 4px 12px rgba(0,0,0,0.04) !important;">
            <v-expansion-panel-header class="px-6 py-4">
              <template v-slot:default="{ open }">
                <v-row no-gutters align="center">
                  <v-col cols="12" sm="8">
                    <div class="font-weight-bold text-subtitle-2" style="color: #1c1f4c;">{{ item.nombres }}</div>
                    <div class="text-body-2 grey--text text--darken-1">{{ item.cargo }}</div>
                  </v-col>
                  <v-col cols="12" sm="4" class="text-sm-right mt-2 mt-sm-0">
                    <span class="text-subtitle-2 grey--text text--darken-1 font-weight-medium"
                      style="margin-right: 12px;">{{ item.fecha }}</span>
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-header>

            <v-expansion-panel-content class="px-2 pb-2">
              <v-divider class="mb-4 mx-4"></v-divider>

              <div class="px-4">
                <div v-for="(comp, index) in [{ title: 'Comparación inicial', data: item.comparacion_inicial }, { title: 'Comparación final', data: item.comparacion_final }].filter(c => c.data)" :key="index" class="mb-8">
                  <h3 class="text-subtitle-1 font-weight-bold mb-4" style="color: #1c1f4c;">{{ comp.title }}</h3>

                  <!-- Variante Servicios Profesionales -->
                  <template v-if="esTipoHonorarios">
                    <v-row dense class="d-flex justify-space-between">
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Nombre de la plaza*" outlined dense :readonly="true"
                          :value="comp.data.nombrePlaza || item.cargo" />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg calculator-icon-bold" :label="`${etiquetaRemuneracion}*`" outlined dense :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.honorario)" append-icon="mdi-calculator" />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" :label="`${etiquetaTotalRemuneracion}*`" outlined :readonly="true" dense
                          :value="formatCurrency(comp.data.aportaciones?.totalHonorariosMensual)" />
                      </v-col>
                    </v-row>
                    <v-row dense class="d-flex justify-space-between">
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Costo por plaza*" outlined :readonly="true" dense
                          :value="formatCurrency(comp.data.aportaciones?.costoPlaza)" />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Plazas*" outlined :readonly="true" dense
                          :value="comp.data.aportaciones?.plazas" />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Costo total plazas*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.costoTotalPlazas)" dense />
                      </v-col>
                    </v-row>
                    <v-row dense class="d-flex justify-space-between">
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Impuesto Sobre la Renta (ISR)*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.isr)" dense />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Total ISR*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.totalIsr)" dense />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Salario mínimo*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.salarioMinimo)" dense />
                      </v-col>
                    </v-row>
                    <v-row dense class="d-flex justify-space-between">
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Salario máximo*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.salarioMaximo)" dense />
                      </v-col>
                      <v-col cols="12" md="4"></v-col>
                      <v-col cols="12" md="4"></v-col>
                    </v-row>
                  </template>

                  <!-- Variante normal (Contrato GOES / Plaza vacante / Contratación directa) -->
                  <template v-else>
                    <v-row dense class="d-flex justify-space-between">
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Nombre de la plaza*" outlined dense :readonly="true"
                          :value="comp.data.nombrePlaza || item.cargo" />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg calculator-icon-bold" :label="`${etiquetaRemuneracion}*`" outlined dense :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.honorario)" append-icon="mdi-calculator" />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" :label="`${etiquetaTotalRemuneracion}*`" outlined :readonly="true" dense
                          :value="formatCurrency(comp.data.aportaciones?.totalHonorariosMensual)" />
                      </v-col>
                    </v-row>
                    <v-row dense class="d-flex justify-space-between">
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Costo por plaza*" outlined :readonly="true" dense
                          :value="formatCurrency(comp.data.aportaciones?.costoPlaza)" />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Plazas*" outlined :readonly="true" dense
                          :value="comp.data.aportaciones?.plazas" />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Costo total plazas*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.costoTotalPlazas)" dense />
                      </v-col>
                    </v-row>
                    <v-row dense class="d-flex justify-space-between">
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Instituto Salvadoreño del Seguro Social (ISSS)*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.isss)" dense />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Administración de Fondos de Pensiones (AFP)*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.afp)" dense />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Impuesto Sobre la Renta (ISR)*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.isr)" dense />
                      </v-col>
                    </v-row>
                    <v-row dense class="d-flex justify-space-between">
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Total ISSS*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.totalIsss)" dense />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Total AFP*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.totalAfp)" dense />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Total ISR*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.totalIsr)" dense />
                      </v-col>
                    </v-row>
                    <v-row dense class="d-flex justify-space-between">
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Salario mínimo*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.salarioMinimo)" dense />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Salario máximo*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.salarioMaximo)" dense />
                      </v-col>
                      <v-col cols="12" md="4"></v-col>
                    </v-row>
                    <v-row dense class="d-flex justify-space-between">
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Aguinaldo individual*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.aguinaldoIndividual)" dense
                          :hint="comp.data.calculado_aguinaldo_salario != null ? (comp.data.calculado_aguinaldo_salario ? 'Aguinaldo calculado con salario mínimo' : 'Aguinaldo calculado con salario base') : ''"
                          persistent-hint />
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field class="rounded-lg" label="Aguinaldo total*" outlined :readonly="true"
                          :value="formatCurrency(comp.data.aportaciones?.aguinaldoTotal)" dense />
                      </v-col>
                      <v-col cols="12" md="4"></v-col>
                    </v-row>
                  </template>

                  <v-divider v-if="index === 0 && item.comparacion_final" class="my-6"></v-divider>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <!-- Actions -->
      <v-card-actions class="justify-center pt-6 pb-2">
        <v-btn outlined color="#1c1f4c" class="text-none rounded-xl px-8 py-5" @click="close">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BitacoraModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    esServiciosProfesionales: {
      type: Boolean,
      default: false,
    },
    idTipoSolicitud: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      panel: null,
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    esTipoHonorarios() {
      return Number(this.idTipoSolicitud) === 3 || this.esServiciosProfesionales;
    },
    etiquetaRemuneracion() {
      return this.esTipoHonorarios ? "Honorarios" : "Salario";
    },
    etiquetaTotalRemuneracion() {
      return this.esTipoHonorarios
        ? "Total honorarios mensual por plaza"
        : "Total salarios mensual por plaza";
    },
  },
  methods: {
    close() {
      this.internalValue = false;
    },
    formatCurrency(value) {
      if (!value && value !== 0) return '';
      const numValue = typeof value === 'string' ? parseFloat(value) : value;
      if (isNaN(numValue)) return '';
      return `$${numValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    },
  },
};
</script>

<style scoped lang="scss">
.v-expansion-panel::before {
  box-shadow: none !important;
}

.border {
  border: 1px solid #e0e0e0;
}

:deep(.text-subtitle-2) {
    font-family: 'MuseoSans', sans-serif !important;
}

:deep(.text-body-2) {
    font-family: 'MuseoSans', sans-serif !important;
}

.calculator-icon-bold:not(.v-input--is-disabled) ::v-deep .v-input__append-inner .v-icon {
  font-weight: 900 !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>
